<template>
  <div class="sat-container">
    <div class="row">
      <div class="col-lg-12 stretch-card">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">SAT Maintenance</h4>
            <div class="filters">
              <div class="row mb-3">
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                  <div class="row">
                    <div class="col">
                      <label>Territory Code:</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="filter.territoryCode"
                        placeholder="Territory Code"
                        :disabled="isSearching"
                      />
                    </div>
                    <div class="col">
                      <p style="margin-bottom: 0.3rem">&nbsp;</p>
                      <button
                        type="button"
                        class="btn btn-primary"
                        @click="searchFilter"
                        :disabled="isSearching"
                      >
                        <i class="fas fa-search"></i>
                        Search
                      </button>
                    </div>
                  </div>
                </div>
                <div
                  class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 text-right"
                >
                  <p style="margin-bottom: 0rem">&nbsp;</p>
                  <!-- <button
                    type="button"
                    class="btn btn-primary btn-sm-block mt-1"
                    :disabled="isSearching || isDownloading"
                    @click="downloadTemplate"
                  >
                    <i class="fas fa-download"></i>
                    Export SAT
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary btn-sm-block mt-1 ml-xl-2 ml-lg-2 ml-md-2 ml-sm-2"
                    :disabled="isSearching"
                    @click="
                      isEdit = false;
                      stateAreaTerritoryModalShow =
                        !stateAreaTerritoryModalShow;
                      listEmailStockOnHand = [];
                      listEmailDeliveryMonitoring = [];
                      listEmailInvoiceListing = [];
                      $store.dispatch('satController/ResetStateAreaTerritory');
                    "
                  >
                    <i class="fas fa-user-plus"></i>
                    Add SAT
                  </button> -->
                  <button
                    type="button"
                    :disabled="isSearching"
                    class="btn btn-primary btn-sm-block mt-1 ml-xl-2 ml-lg-2 ml-md-2 ml-sm-2"
                    @click="
                      isEdit = false;
                      uploadstateAreaTerritoryModalShow =
                        !uploadstateAreaTerritoryModalShow;
                      $store.dispatch('satController/ResetStateAreaTerritory');
                    "
                  >
                    <i class="fas fa-upload"></i>
                    Upload SAT
                  </button>
                  <!-- <button type="button"
                          :disabled="isSearching || isSyncing"
                          class="btn btn-primary btn-sm-block mt-1 ml-xl-2 ml-lg-2 ml-md-2 ml-sm-2"
                          @click="syncPrincipal">
                      <i class="fas fa-sync" :class="{ 'fa-spin': isSyncing }"></i>
                      {{ isSyncing ? 'Syncing...' : 'Sync from Summit' }}
                  </button> -->
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th>State</th>
                    <th>Area</th>
                    <th>Territory</th>
                    <th>State Code</th>
                    <th>Area Code</th>
                    <th>Territory Code</th>
                    <th>Sales Agent Code</th>
                    <th>Sales Agent Name</th>
                    <th>Bill Collector Code</th>
                    <th>Bill Collector Name</th>
                    <th>DM Code</th>
                    <th>DM Name</th>
                    <th>NSM Code</th>
                    <th>NSM Name</th>
                    <th>Remarks</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-if="
                      stateAreaTerritoriesPageItems.length == 0 && !isSearching
                    "
                  >
                    <td colspan="16">
                      <div>
                        <lottie-animation
                          style="height: 500px"
                          :loop="true"
                          :animationData="
                            require('@/assets/lottie/no-data.json')
                          "
                        />
                      </div>
                    </td>
                  </tr>
                  <tr v-if="isSearching">
                    <td colspan="16">
                      <div class="text-center">
                        <i class="fas fa-spinner fa-spin mr-1" />
                        <span>Loading. . .</span>
                      </div>
                    </td>
                  </tr>
                  <tr
                    v-for="(
                      stateAreaTerritory, i
                    ) in stateAreaTerritoriesPageItems"
                    :key="i"
                  >
                    <td>{{ stateAreaTerritory.state }}</td>
                    <td>{{ stateAreaTerritory.area }}</td>
                    <td>{{ stateAreaTerritory.territory }}</td>
                    <td>{{ stateAreaTerritory.stateCode }}</td>
                    <td>{{ stateAreaTerritory.areaCode }}</td>
                    <td>{{ stateAreaTerritory.territoryCode }}</td>
                    <td>{{ stateAreaTerritory.salesAgentCode }}</td>
                    <td>{{ stateAreaTerritory.salesAgentName }}</td>
                    <td>{{ stateAreaTerritory.billCollectorCode }}</td>
                    <td>{{ stateAreaTerritory.billCollectorName }}</td>
                    <td>{{ stateAreaTerritory.dmCode }}</td>
                    <td>{{ stateAreaTerritory.dmName }}</td>
                    <td>{{ stateAreaTerritory.nsmCode }}</td>
                    <td>{{ stateAreaTerritory.nsmName }}</td>
                    <td>{{ stateAreaTerritory.remarks }}</td>
                    <td>
                      <!-- <a
                        href="#"
                        @click="
                          editStateAreaTerritory(stateAreaTerritory);
                          isEdit = true;
                        "
                      >
                        Edit
                      </a>
                      |
                      <a href="#" @click="deleteStateAreaTerritory(stateAreaTerritory)">Delete</a> -->
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <b-pagination
              v-if="stateAreaTerritoriesPageItems.length != 0"
              v-model="currentPage"
              :total-rows="rows"
              :per-page="pageSize"
              aria-controls="my-table"
              @change="paginationChanged"
              style="float: right; margin-top: 20px"
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      v-model="stateAreaTerritoryModalShow"
      size="xl"
      title="Customer Details"
      hide-footer
      no-close-on-backdrop
    >
      <!-- <form class="forms-sample">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="txtCustomerCode" ref="modalCustomerDetails">
                Customer Code
              </label>
              <input
                type="text"
                class="form-control"
                id="txtCustomerCode"
                placeholder="Customer Code"
                :class="{
                  'is-invalid': $v.customer.customerCode.$error,
                }"
                v-model="$v.customer.customerCode.$model"
                :disabled="isEdit"
              />
              <div class="form-error" v-if="$v.customer.customerCode.$error">
                Customer Code is required.
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="txtCustomerName">Customer Name</label>
              <input
                type="text"
                class="form-control"
                id="txtCustomerName"
                placeholder="Customer Name"
                :class="{
                  'is-invalid': $v.customer.customerName.$error,
                }"
                v-model="$v.customer.customerName.$model"
              />
              <div class="form-error" v-if="$v.customer.customerName.$error">
                Customer Name is required.
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="txtCustomerAddress">Customer Address</label>
              <input
                type="text"
                class="form-control"
                id="txtCustomerAddress"
                placeholder="Customer Address"
                :class="{
                  'is-invalid': $v.customer.customerAddress.$error,
                }"
                v-model="$v.customer.customerAddress.$model"
              />
              <div class="form-error" v-if="$v.customer.customerAddress.$error">
                CustomerAddress is required.
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="txtShipToCode">Ship To Code</label>
              <input
                type="text"
                class="form-control"
                id="txtShipToCode"
                placeholder="Ship To Code"
                :class="{
                  'is-invalid': $v.customer.shipToCode.$error,
                }"
                v-model="$v.customer.shipToCode.$model"
              />
              <div class="form-error" v-if="$v.customer.shipToCode.$error">
                Ship To Code is required.
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="txtShipToAddress">Ship To Address</label>
              <input
                type="text"
                class="form-control"
                id="txtShipToAddress"
                placeholder="Ship To Address"
                :class="{
                  'is-invalid': $v.customer.shipToAddress.$error,
                }"
                v-model="$v.customer.shipToAddress.$model"
              />
              <div class="form-error" v-if="$v.customer.shipToAddress.$error">
                Ship To Address is required.
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="txtZipCode">Zip Code</label>
              <input
                type="text"
                class="form-control"
                id="txtZipCode"
                placeholder="Zip Code"
                :class="{
                  'is-invalid': $v.customer.zipCode.$error,
                }"
                v-model="$v.customer.zipCode.$model"
              />
              <div class="form-error" v-if="$v.customer.zipCode.$error">
                Zip Code is required.
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="txtBillCollectorCode">Bill Collector Code</label>
              <input
                type="text"
                class="form-control"
                id="txtBillCollectorCode"
                placeholder="Bill Collector Code"
                :class="{
                  'is-invalid': $v.customer.billCollectorCode.$error,
                }"
                v-model="$v.customer.billCollectorCode.$model"
              />
              <div
                class="form-error"
                v-if="$v.customer.billCollectorCode.$error"
              >
                Bill Collector Code is required.
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="txtBillCollectorName">Bill Collector Name</label>
              <input
                type="text"
                class="form-control"
                id="txtBillCollectorName"
                placeholder="Bill Collector Name"
                :class="{
                  'is-invalid': $v.customer.billCollectorName.$error,
                }"
                v-model="$v.customer.billCollectorName.$model"
              />
              <div
                class="form-error"
                v-if="$v.customer.billCollectorName.$error"
              >
                Bill Collector Name is required.
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="txtSalesAgentCode">Sales Agent Code</label>
              <input
                type="text"
                class="form-control"
                id="txtSalesAgentCode"
                placeholder="Sales Agent Code"
                :class="{
                  'is-invalid': $v.customer.salesAgentCode.$error,
                }"
                v-model="$v.customer.salesAgentCode.$model"
              />
              <div class="form-error" v-if="$v.customer.salesAgentCode.$error">
                Sales Agent Code is required.
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="txtSalesAgentName">Sales Agent Name</label>
              <input
                type="text"
                class="form-control"
                id="txtSalesAgentName"
                placeholder="Sales Agent Name"
                :class="{
                  'is-invalid': $v.customer.salesAgentName.$error,
                }"
                v-model="$v.customer.salesAgentName.$model"
              />
              <div class="form-error" v-if="$v.customer.salesAgentName.$error">
                Sales Agent Name is required.
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="txtDMCode">DM Code</label>
              <input
                type="text"
                class="form-control"
                id="txtDMCode"
                placeholder="DM Code"
                v-model="customer.dmCode"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="txtDMName">DM Name</label>
              <input
                type="text"
                class="form-control"
                id="txtDMName"
                placeholder="DM Name"
                v-model="customer.dmName"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="txtContactNumber">Contact Number</label>
              <input
                type="text"
                class="form-control"
                id="txtContactNumber"
                placeholder="Contact Number"
                v-model="customer.contactNumber"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="txtContactPerson">Contact Person</label>
              <input
                type="text"
                class="form-control"
                id="txtContactPerson"
                placeholder="Contact Person"
                v-model="customer.contactPerson"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="txtCreditTermCode">Credit Term Code</label>
              <input
                type="text"
                class="form-control"
                id="txtCreditTermCode"
                placeholder="Credit Term Code"
                :class="{
                  'is-invalid': $v.customer.creditTermCode.$error,
                }"
                v-model="$v.customer.creditTermCode.$model"
              />
              <div class="form-error" v-if="$v.customer.creditTermCode.$error">
                Credit Term Code is required.
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="txtCreditTermDescription"
                >Credit Term Description</label
              >
              <input
                type="text"
                class="form-control"
                id="txtCreditTermDescription"
                placeholder="Credit Term Description"
                :class="{
                  'is-invalid': $v.customer.creditTermDescription.$error,
                }"
                v-model="$v.customer.creditTermDescription.$model"
              />
              <div
                class="form-error"
                v-if="$v.customer.creditTermDescription.$error"
              >
                Credit Term Description is required.
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="txtCustomerClass">Customer Class</label>
              <input
                type="text"
                class="form-control"
                id="txtCustomerClass"
                placeholder="Customer Class"
                :class="{
                  'is-invalid': $v.customer.customerClass.$error,
                }"
                v-model="$v.customer.customerClass.$model"
              />
              <div class="form-error" v-if="$v.customer.customerClass.$error">
                Customer Class is required.
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="txtTIN">TIN</label>
              <input
                type="text"
                class="form-control"
                id="txtTIN"
                placeholder="TIN"
                v-model="customer.tin"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="txtLTONumber">LTO Number</label>
              <input
                type="text"
                class="form-control"
                id="txtLTONumber"
                placeholder="LTO Number"
                v-model="customer.ltoNumber"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="txtLTOExpiryDate">LTO Expiry Date</label>
              <date-picker
                v-model="customer.ltoExpiryDate"
                :clearable="false"
                input-class="form-control"
                :input-attr="{ id: 'txtLTOExpiryDate' }"
              ></date-picker>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="txtSLicense">S License</label>
              <input
                type="text"
                class="form-control"
                id="txtSLicense"
                placeholder="S License"
                v-model="customer.sLicense"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="txtSLicenseExpiryDate">S License Expiry Date</label>
              <date-picker
                v-model="customer.sLicenseExpiryDate"
                :clearable="false"
                input-class="form-control"
                :input-attr="{ id: 'txtSLicenseExpiryDate' }"
              ></date-picker>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="txtVATStatus">VAT Status</label>
              <input
                type="text"
                class="form-control"
                id="txtVATStatus"
                placeholder="VAT Status"
                :class="{
                  'is-invalid': $v.customer.vatStatus.$error,
                }"
                v-model="$v.customer.vatStatus.$model"
              />
              <div class="form-error" v-if="$v.customer.vatStatus.$error">
                VAT Status is required.
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="txtOwnerName">Owner Name</label>
              <input
                type="text"
                class="form-control"
                id="txtOwnerName"
                placeholder="Owner Name"
                v-model="customer.ownerName"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="txtState">State</label>
              <input
                type="text"
                class="form-control"
                id="txtState"
                placeholder="State"
                :class="{
                  'is-invalid': $v.customer.state.$error,
                }"
                v-model="$v.customer.state.$model"
              />
              <div class="form-error" v-if="$v.customer.state.$error">
                State is required.
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="txtArea">Area</label>
              <input
                type="text"
                class="form-control"
                id="txtArea"
                placeholder="Area"
                :class="{
                  'is-invalid': $v.customer.area.$error,
                }"
                v-model="$v.customer.area.$model"
              />
              <div class="form-error" v-if="$v.customer.area.$error">
                Area is required.
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="txtTerritory">Territory</label>
              <input
                type="text"
                class="form-control"
                id="txtTerritory"
                placeholder="Territory"
                :class="{
                  'is-invalid': $v.customer.territory.$error,
                }"
                v-model="$v.customer.territory.$model"
              />
              <div class="form-error" v-if="$v.customer.territory.$error">
                Territory is required.
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="txtCreatedDate">Created Date</label>
              <date-picker
                :clearable="false"
                input-class="form-control"
                :input-attr="{ id: 'txtCreatedDate' }"
                :class="{
                  'is-invalid': $v.customer.createdDate.$error,
                }"
                v-model="$v.customer.createdDate.$model"
              ></date-picker>
              <div class="form-error" v-if="$v.customer.createdDate.$error">
                Created Date is required.
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="txtCreatedTime">Created Time</label>
              <input
                type="text"
                class="form-control"
                id="txtCreatedTime"
                placeholder="Created Time"
                :class="{
                  'is-invalid': $v.customer.createdTime.$error,
                }"
                v-model="$v.customer.createdTime.$model"
              />
              <div class="form-error" v-if="$v.customer.createdTime.$error">
                Created Time is required.
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="txtCreatedBy">Created By</label>
              <input
                type="text"
                class="form-control"
                id="txtCreatedBy"
                placeholder="Created By"
                :class="{
                  'is-invalid': $v.customer.createdBy.$error,
                }"
                v-model="$v.customer.createdBy.$model"
              />
              <div class="form-error" v-if="$v.customer.createdBy.$error">
                Created By is required.
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col">
            <button
              type="button"
              class="btn btn-primary mr-2"
              @click="submitCustomer"
            >
              Submit
            </button>
            <button
              type="button"
              class="btn btn-outline-light"
              @click="
                stateAreaTerritoryModalShow = !stateAreaTerritoryModalShow;
                $v.$reset();
              "
            >
              Cancel
            </button>
          </div>
        </div>
      </form> -->
    </b-modal>

    <!-- upload modal -->
    <b-modal
      v-model="uploadstateAreaTerritoryModalShow"
      size="md"
      title="Upload SAT"
      hide-footer
      no-close-on-backdrop
    >
      <form class="forms-sample">
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label for="txtFirstName">SAT File</label>
              <input
                class="form-control"
                type="file"
                v-on:change="handleFileUpload($event)"
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              />
            </div>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col">
            <button
              type="button"
              class="btn btn-primary mr-2"
              @click="uploadFile"
            >
              Upload
            </button>
            <button
              type="button"
              class="btn btn-outline-light"
              @click="
                uploadstateAreaTerritoryModalShow =
                  !uploadstateAreaTerritoryModalShow
              "
            >
              Cancel
            </button>
          </div>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import LottieAnimation from "lottie-web-vue";
import { required, minLength } from "vuelidate/lib/validators";

export default {
  components: {
    LottieAnimation,
  },
  data() {
    return {
      file: null,
      uploadstateAreaTerritoryModalShow: false,
      stateAreaTerritoriesPageItems: [],
      listEmailInvoiceListing: [],
      listEmailStockOnHand: [],
      listEmailDeliveryMonitoring: [],
      options: [],
      stateAreaTerritoryModalShow: false,
      pageSize: 50,
      currentPage: 1,
      isSearching: false,
      isDownloading: false,
      isEdit: false,
      sSyncing: false,
    };
  },

  validations: {
    file: {
      required,
    },
    customer: {
      customerCode: {
        required,
      },
      customerName: {
        required,
      },
      customerAddress: {
        required,
      },
      shipToCode: {
        required,
      },
      shipToAddress: {
        required,
      },
      zipCode: {
        required,
      },
      billCollectorCode: {
        required,
      },
      billCollectorName: {
        required,
      },
      salesAgentCode: {
        required,
      },
      salesAgentName: {
        required,
      },
      creditTermCode: {
        required,
      },
      creditTermDescription: {
        required,
      },
      customerClass: {
        required,
      },
      vatStatus: {
        required,
      },
      state: {
        required,
      },
      area: {
        required,
      },
      territory: {
        required,
      },
      createdDate: {
        required,
      },
      createdTime: {
        required,
      },
      createdBy: {
        required,
      },
    },
  },
  computed: {
    ...mapState({
      stateAreaTerritories: (state) => state.satController.stateAreaTerritories,
      stateAreaTerritory: (state) => state.satController.stateAreaTerritory,
      filter: (state) => state.satController.filters,
    }),
    rows() {
      return this.stateAreaTerritories.length;
    },
  },
  methods: {
    handleFileUpload(event) {
      this.file = event.target.files[0];
    },
    async uploadFile() {
      await this.$store.dispatch("showOverlay", true);
      var result = await this.$store
        .dispatch("satController/UploadStateAreaTerritory", this.file)
        .catch(async (error) => {
          await this.$store.dispatch("showOverlay", false);
          this.$toast.open({
            message: error.data,
            type: "error",
          });
        });

      if (result) {
        await this.searchFilter();
        await this.$store.dispatch("showOverlay", false);
        this.uploadstateAreaTerritoryModalShow = false;
        this.$toast.open({
          message: "SAT batch file has been successfully uploaded.",
          type: "success",
        });
      }
    },
    paginationChanged: function (page) {
      if (page == null) {
        page = 1;
      }

      this.stateAreaTerritoriesPageItems = this.stateAreaTerritories.slice(
        (page - 1) * this.pageSize,
        page * this.pageSize
      );
    },
    validateEmail: function (email) {
      return String(email)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    },
    downloadTemplate: async function () {
      this.isDownloading = true;
      var result = await this.$store.dispatch("satController/DownloadTemplate");

      if (result) {
        this.isDownloading = false;
      }
    },
    searchFilter: async function () {
      this.currentPage = 1;
      this.stateAreaTerritoriesPageItems = [];
      this.isSearching = true;
      var result = await this.$store
        .dispatch("satController/GetStateAreaTerritories")
        .catch((error) => {
          this.isSearching = false;
        });

      if (result) {
        this.paginationChanged(this.currentPage);
        this.isSearching = false;
      }
    },
    submitCustomer: async function () {
      this.$v.customer.$touch();

      if (!this.$v.customer.$invalid) {
        if (this.isEdit) {
          await this.$store.dispatch("showOverlay", true);
          // edit existing record
          var result = await this.$store
            .dispatch("satController/editStateAreaTerritory")
            .catch(async (error) => {
              await this.$store.dispatch("showOverlay", false);
              this.$toast.open({
                message: error.data.Message,
                type: "error",
              });
            });

          if (result) {
            await this.$store.dispatch("showOverlay", false);
            this.$toast.open({
              message: "Customer has been successfully edited.",
              type: "success",
            });

            this.paginationChanged(this.currentPage);

            this.stateAreaTerritoryModalShow = false;
            this.listEmailInvoiceListing = [];
            this.listEmailStockOnHand = [];
            this.listEmailDeliveryMonitoring = [];

            this.$v.customer.$reset();
          }
        } else {
          await this.$store.dispatch("showOverlay", true);
          // insert new record
          var result = await this.$store
            .dispatch("satController/AddCustomer")
            .catch(async (error) => {
              await this.$store.dispatch("showOverlay", false);
              this.$toast.open({
                message: error.data.Message,
                type: "error",
              });
            });

          if (result) {
            await this.$store.dispatch("showOverlay", false);
            this.$toast.open({
              message: "Customer has been successfully added.",
              type: "success",
            });

            this.paginationChanged(this.currentPage);

            this.stateAreaTerritoryModalShow = false;
            this.listEmailInvoiceListing = [];
            this.listEmailStockOnHand = [];
            this.listEmailDeliveryMonitoring = [];

            this.$v.customer.$reset();
          }
        }
      }
    },
    editStateAreaTerritory: function (customer) {
      this.$store.dispatch("satController/BindCustomer", customer);
      this.stateAreaTerritoryModalShow = !this.stateAreaTerritoryModalShow;
    },
    deleteStateAreaTerritory: function (customer) {
      var self = this;
      self.$store.dispatch("satController/BindCustomer", customer);

      self.$bvModal
        .msgBoxConfirm(
          "Are you sure you want to delete " + customer.customerCode + "?",
          {
            title: "Delete Customer",
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "YES",
            cancelTitle: "NO",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then(async (value) => {
          if (value) {
            var result = await self.$store.dispatch(
              "satController/DeleteCustomer",
              customer
            );

            if (result) {
              self.$toast.open({
                message:
                  "Customer " +
                  customer.customerCode +
                  " has been successfully deleted.",
                type: "success",
              });

              self.paginationChanged(self.currentPage);
            }
          }
        })
        .catch((err) => {});
    },
    syncPrincipal: async function () {
      await this.$store.dispatch("showOverlay", true);

      var result = await this.$store
          .dispatch("satController/SyncSAT")
          .catch(async (error) => {
              await this.$store.dispatch("showOverlay", false);
              this.$toast.open({
                  message: error.data?.message || "Failed to sync customer. Please try again.",
                  type: "error",
              });
          });
      if (result) {
          await this.$store.dispatch("showOverlay", false);
          this.$toast.open({
              message: "Customer have been successfully synced from ORS.",
              type: "success",
          });
          // Refresh by fetching fresh data from API
          await this.searchFilter();  // ? This fetches fresh data from the API!
      }
    },
  },
  async mounted() {
    await this.searchFilter();
  },
};
</script>

<style>
</style>